import HIKInsanCitaLogo from "@/assets/images/landing_page/img-logo-hik-insan-cita.png";
import HIKParahyanganLogo from "@/assets/images/landing_page/img-logo-hik-parahyangan.png";
import BPRSAttaqwaLogo from "@/assets/images/landing_page/img-logo-attaqwa.png";
import BankHijraLogo from "@/assets/images/landing_page/img-logo-bank-hijra.png";
import BPRSBotaniLogo from "@/assets/images/landing_page/img-logo-bprs.png";

export const efundingPartnersLogo = [
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
  {
    id: 1,
    label: "HIK Insan Cita",
    logo: HIKInsanCitaLogo,
  },
  {
    id: 2,
    label: "HIK Parahyangan",
    logo: HIKParahyanganLogo,
  },
  {
    id: 3,
    label: "BPRS Attaqwa",
    logo: BPRSAttaqwaLogo,
  },
  {
    id: 4,
    label: "Bank hijra",
    logo: BankHijraLogo,
  },
  {
    id: 5,
    label: "BPRS Botani",
    logo: BPRSBotaniLogo,
  },
];



// WEBPACK FOOTER //
// ./src/utils/efunding_partners_logo.js